import ExcelJS from 'exceljs';
import { generateCellarSummarySheet } from 'utils/excelGenerators';
import { generateInventorySheetRDM } from './generateInventorySheetRDM';
import { generateTodayOperationsSheetDRM } from './generateTodayOperationsSheetDRM';

export const generateXLSXDRM = async (lastOpsAndTanks, globalState, t, cellarsRef) => {
  const { lastOps, tankDataMap } = lastOpsAndTanks;
  const volumeUnit = lastOps[0]?.form.volumeUnit || 'hL';

  // Create a new workbook
  const workbook = new ExcelJS.Workbook();
  workbook.creator = 'Labox';
  workbook.lastModifiedBy = 'Labox';
  workbook.created = new Date();
  workbook.modified = new Date();

  // First worksheet (inventory)
  const ws = workbook.addWorksheet('Dernières opérations par cuve');
  await generateInventorySheetRDM(ws, lastOps, tankDataMap, volumeUnit, globalState.extraOperationFields, t, cellarsRef);

  // Set print settings for first worksheet
  ws.pageSetup = {
    orientation: 'portrait',
    fitToPage: true,
    fitToWidth: 1,
    fitToHeight: 1,
    margins: {
      left: 0.2,
      right: 0.2,
      top: 0.2,
      bottom: 0.2,
      header: 0.1,
      footer: 0.1
    },
  };

  const cellarFilter1 = 'CUVES JOURNALIERES';
  const cellarFilter2 = 'CUVES MAUVAIS GOUT';

  // Filter today's operations of cellar "CUVES JOURNALIERES"
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  const todayOpsCJ = lastOps.filter(op => {
    const opDate = new Date(op.dateAndTime.seconds * 1000 + op.dateAndTime.nanoseconds / 1000000);
    return opDate >= today && op.cellarName === cellarFilter1;
  });

  // Filter today's operations of cellar "CUVES MAUVAIS GOUT"
  const todayOpsMG = lastOps.filter(op => {
    const opDate = new Date(op.dateAndTime.seconds * 1000 + op.dateAndTime.nanoseconds / 1000000);
    return opDate >= today && op.cellarName === cellarFilter2;
  });

  // Second worksheet (today's operations)
  const ws2 = workbook.addWorksheet('Suivi Jour prod Bacs Compteurs');
  const ws3 = workbook.addWorksheet('Suivi Jour prod MG');

  generateTodayOperationsSheetDRM(ws2, todayOpsCJ, volumeUnit, t, 'DECLARATIONS PRODUCTION BACS JOURNALIERS');
  generateTodayOperationsSheetDRM(ws3, todayOpsMG, volumeUnit, t, 'DECLARATIONS PRODUCTION CUVES MAUVAIS GOUT');

  // Set print settings for other worksheets
  [ws2, ws3].forEach(sheet => {
    sheet.pageSetup = {
      orientation: 'portrait',
      fitToPage: true,
      fitToWidth: 1,
      fitToHeight: 1,
      margins: {
        left: 0.2,
        right: 0.2,
        top: 0.2,
        bottom: 0.2,
        header: 0.1,
        footer: 0.1
      },
    };
  });

  // Third worksheet (cellar summaries)
  const ws4 = workbook.addWorksheet('Résumé par chai');
  generateCellarSummarySheet(ws4, lastOps, volumeUnit, t);

  // Set print settings for cellar summary worksheet
  ws4.pageSetup = {
    orientation: 'portrait',
    fitToPage: true,
    fitToWidth: 1,
    fitToHeight: 1,
    margins: {
      left: 0.2,
      right: 0.2,
      top: 0.2,
      bottom: 0.2,
      header: 0.1,
      footer: 0.1
    },
  };

  const day = String(today.getDate()).padStart(2, '0');
  const month = String(today.getMonth() + 1).padStart(2, '0');
  const year = today.getFullYear();
  const formattedDate = `${day}/${month}/${year}`;

  // Write the file
  const buffer = await workbook.xlsx.writeBuffer();
  
  // Create a blob and download link
  const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
  const url = window.URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = `inventaire-${formattedDate}.xlsx`;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  window.URL.revokeObjectURL(url);
};
